/// <reference path="index.d.ts" />
import 'core-js/stable';
import { CapacitorStatusBarInitialization } from 'modules/app';
import 'styles/global.scss';
import 'utils/CustomEventPolyfill';
import { isCordova } from 'utils/platform';
import useAuthStore from '~/authentication/store';
import { useDeviceInfoStore } from '~/stores/device';

import Main from './Main';
import UI from './ui';

function loadMain() {
  Main();
  UI();
  if (isCordova()) {
    (async () => {
      await useAuthStore.persist.rehydrate();
      await CapacitorStatusBarInitialization();
      await useDeviceInfoStore.getState().init();
    })();
  }
  console.log('loaded main and UI');
}

if (isCordova()) {
  document.addEventListener('deviceready', loadMain, false);
} else {
  loadMain();
}
